import(/* webpackMode: "eager" */ "/home/turath2/turath-websites/turath-website-learn/ar-prod/app/(website)/(main)/error.tsx");
